import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import queryString from "query-string";
import { ContactAction } from "../../../actions";
import ToolsDescription from "../components/description";
import ToolsSearch from "../components/search";
import Table from "../../../components/table";
import { Sortable } from "../../../components/sort";
import { Confirm } from "../../../components/confirm";
import { EmptyState } from "../../../components/emptyState";
import { BoxLoading } from "../../../components/loading";
import { EmploymentTypeTitle } from "../../../constants/employmentType";
import { ToolsTop, ToolsBody } from "../style";
import { ToPersian } from "../../../lib/changeNumber";
import ToEnglish from "../../../lib/persianNumberToEnglish";

class Contact extends Component {
  constructor(props) {
    super(props);

    this.state = {
      query: null,
      sortField: "fullname",
      sortType: "asc",
      showModal: false
    };

    this.sortHandleClick = this.sortHandleClick.bind(this);
    this.onSearch = this.onSearch.bind(this);
    this.deleteHandleClick = this.deleteHandleClick.bind(this);
    this.onEdit = this.onEdit.bind(this);
    this.toggleFavorite = this.toggleFavorite.bind(this);
    this.rowRender = this.rowRender.bind(this);
  }

  static getDerivedStateFromProps(props, state) {
    let result = { ...state };
    result.favorite = queryString.parse(
      props.history.location.search
    ).favtories;
    return result;
  }

  componentDidMount() {
    this.props.getAll();
  }

  async sortHandleClick(sortField) {
    const { sortType } = this.state;

    this.setState({
      sortField,
      sortType: sortType === "desc" ? "asc" : "desc"
    });
  }

  onEdit(id) {
    this.props.history.push(`/contact/${id}/edit`);
  }

  onSearch(query) {
    this.setState({
      query: query
    });
  }

  toggleFavorite(id, status) {
    this.props.addFavorite(id, status);
  }

  deleteHandleClick(item) {
    this.setState({ showConfirm: true, deleteItemId: item.id });
  }

  rowRender(item) {
    const { accounting } = this.props;

    return (
      <Table.Row key={item.id}>
        <Table.Cell onClick={() => this.onEdit(item.id)} className="name">
          {item.fullname}
        </Table.Cell>
        <Table.Cell
          onClick={() => this.onEdit(item.id)}
          className="phone_number"
        >
          {item.phone_number}
        </Table.Cell>
        <Table.Cell
          onClick={() => this.onEdit(item.id)}
          className="employment_type"
        >
          {EmploymentTypeTitle[item.employment_type]}
        </Table.Cell>
        {accounting && (
          <Table.Cell
            onClick={() => this.onEdit(item.id)}
            className="accounting"
          >
            {item.accounting_codes &&
              item.accounting_codes.map(account => account.code).join("-")}
          </Table.Cell>
        )}
        <Table.Cell className="row-controls-button">
          <div className="hidden-td">
            <i
              onClick={() => this.toggleFavorite(item.id, !item.is_favorite)}
              className={
                "no-select icon yellow" +
                (item.is_favorite
                  ? " mapsa-filled-favourites-star active"
                  : " mapsa-favourites-star")
              }
              title="منتخب"
            />
            <i
              onClick={() => this.deleteHandleClick(item)}
              className="no-select icon mapsa-delete red"
              title="حذف"
            />
          </div>
        </Table.Cell>
      </Table.Row>
    );
  }

  render() {
    const description =
      "کلیه فروشندگان، پیمانکاران، کارکنان، سرمایه گذاران و سایر اشخاص طرف حساب را باید به عنوان مخاطبین تعریف نمود.";
    const { loading, list, accounting } = this.props;
    const {
      showConfirm,
      deleteItemId,
      query,
      favorite,
      sortField,
      sortType
    } = this.state;

    const filteredList = list
      .map(item => {
        let name = "";
        if (item.name) name += item.name + " ";
        if (item.family) name += item.family;
        if (!name.length) name = item.phone_number;

        return { ...item, fullname: name };
      })
      .filter(
        item =>
          !query ||
          item.fullname.indexOf(ToEnglish(query)) !== -1 ||
          item.fullname.indexOf(ToPersian(query)) !== -1
      )
      .filter(item => (favorite ? item.is_favorite : true))
      .sort((prev, next) =>
        sortType === "asc"
          ? prev[sortField] < next[sortField]
            ? -1
            : 1
          : prev[sortField] > next[sortField]
          ? -1
          : 1
      );

    return (
      <React.Fragment>
        {!loading ? (
          list.length !== 0 ? (
            <React.Fragment>
              <ToolsTop>
                <ToolsDescription
                  icon="icon mapsa-phone-book"
                  color="#536dfe"
                  title="مخاطبین حساب"
                  description={description}
                />
                <ToolsSearch onSearch={this.onSearch} query={query} />
              </ToolsTop>
              <ToolsBody>
                {filteredList.length > 0 ? (
                  <Table>
                    <Table.Header>
                      <Table.Row>
                        <Table.HeaderCell className="name">
                          <Sortable
                            sort={{ sortField, sortType, value: "name" }}
                            currency={false}
                            label={"نام مخاطب"}
                            sortHandleClick={this.sortHandleClick}
                          />
                        </Table.HeaderCell>
                        <Table.HeaderCell className="phone_number">
                          شماره همراه
                        </Table.HeaderCell>
                        <Table.HeaderCell className="employment_type">
                          نوع همکاری
                        </Table.HeaderCell>
                        {accounting && (
                          <Table.HeaderCell className="accounting">
                            کد حسابداری
                          </Table.HeaderCell>
                        )}
                        <Table.HeaderCell className="row-controls-button"></Table.HeaderCell>
                      </Table.Row>
                    </Table.Header>
                    <Table.Body>{filteredList.map(this.rowRender)}</Table.Body>
                  </Table>
                ) : (
                  <EmptyState tabIcon={"icon mapsa-search"}>
                    متاسفانه موردی یافت نشد.
                  </EmptyState>
                )}
              </ToolsBody>
              <Confirm
                show={showConfirm}
                content={{
                  type: "danger",
                  icon: "icon mapsa-notification",
                  message: "آیا از پاک کردن این مخاطب اطمینان دارید؟",
                  acceptButtonText: "حذف",
                  rejectButtonText: "انصراف"
                }}
                acceptHandler={() => {
                  this.props.remove(deleteItemId);
                  this.setState({ showConfirm: false });
                }}
                rejectHandler={() => this.setState({ showConfirm: false })}
                close={() => this.setState({ showConfirm: false })}
              />
            </React.Fragment>
          ) : (
            <EmptyState tabIcon={"icon mapsa-outline-layers"}>
              {description}
            </EmptyState>
          )
        ) : (
          <BoxLoading />
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = store => {
  return {
    list: store.Contact.data,
    loading: store.Contact.loading,
    accounting:
      store.Init.data &&
      store.Init.data.project_setting.accounting_software !== null &&
      !!store.Init.data.project_setting.accounting_software.id
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getAll: () => {
      dispatch(ContactAction.getAllRequest());
    },
    addFavorite: (id, status) => {
      dispatch(ContactAction.addFavoriteRequest(id, status));
    },
    remove: id => {
      dispatch(ContactAction.removeRequest(id));
    }
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Contact)
);

export const Sidebar = {
  addButton: { title: "افزودن مخاطب" },
  menu: [
    { title: "مخاطبین", icon: "mapsa-phone-book", link: "/contact" },
    {
      title: "مخاطبین منتخب",
      icon: "mapsa-favourites-star",
      link: "/contact?favtories=true"
    }
  ]
};
